module.exports = __webpack_public_path__ + "img/157.e9a7932c.png";